module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": _vm.onPageEnter,
      "leave": _vm.onPageLeave
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "sub-page-content"
  }, [_c('ImageMesh', {
    attrs: {
      "desc": "blackarea",
      "gclick": function () {},
      "vms": "@play@result@hider",
      "blending": _vm.THREE.NormalBlending,
      "opacity": 1,
      "depthTest": true,
      "transparent": true,
      "link": require('./img/result/hider-reverse.png')
    }
  }), _vm._v(" "), _c('NumberCounter', {
    ref: "number-counter",
    attrs: {
      "word": _vm.$route.query.punch,
      "vms": "@play@result@number-counter"
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@play@result@coupon-box-text",
      "link": require('./img/result/coupon-box-text.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/rules'
        })
      },
      "vms": "@play@result@coupon-box-btn-rule",
      "link": require('./img/result/coupon-box-btn-rule.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.go('https://nike.com')
      },
      "vms": "@play@result@coupon-box-btn-nike",
      "link": require('./img/result/coupon-box-btn-nike.png')
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@play@result@grunge@coupon-box",
      "gclick": function () {}
    },
    on: {
      "exec": function (v) {
        _vm.execStack.grungeCouponBox = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/play'
        })
      },
      "vms": "@play@result@try-again",
      "link": require('./img/result/try-again.png')
    },
    on: {
      "exec": function (v) {
        _vm.execStack.tryAgain = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/status'
        })
      },
      "vms": "@play@result@check-coupon",
      "link": require('./img/result/check-coupon.png')
    },
    on: {
      "exec": function (v) {
        _vm.execStack.checkCoupon = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@play@result@grunge@share-box"
    },
    on: {
      "exec": function (v) {
        _vm.execStack.shareBox = v
      }
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@play@result@share-txt",
      "link": require('./img/result-2/share-txt.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/rules'
        });
      },
      "vms": "@play@result@share-rule-txt",
      "link": require('./img/result-2/share-rule-txt.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.alert('This is demo only.')
      },
      "vms": "@play@result@share-btn",
      "link": require('./img/result-2/share-btn.png')
    },
    on: {
      "final-position": function (props) {
        _vm.tryMaximiseScroller(props);
        this$1.scrollerState.bound.yMax -= 30;
      }
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/daily-task'
        })
      },
      "vms": "@play@result@daily-task-box",
      "link": require('./img/result/daily-task-box.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@play@result@punch-number-desc",
      "link": require('./img/result/punch-number-desc.png')
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0209b3b0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NikeWebGL/Pages/Play/Result.vue
// module id = 573
// module chunks = 0